import React, {useEffect, useState} from 'react';
import {Card, DialogTitle, Grid} from "@material-ui/core";
import {Form, Formik} from "formik";
import {InputTextField, RadioButtonField, SelectField} from "../../../Form/FormElements";
import FormNavigation from "../../../Form/MultistepForm/FormNavigation";
import axios from "axios";
import {config} from "../../../../auth/auth";
import * as Yup from "yup";
import {connect} from "react-redux";
import {withAuth0} from "@auth0/auth0-react";
import {makeStyles} from "@material-ui/core/styles";
import {search} from "../../../../redux/city/action";
import ConfirmationCreatePoiModal from "../../../Modal/ConfirmationCreatePOIModal";

const useStyles = makeStyles(() => ({
  card: {
    borderRadius: '1rem'
  },
  activeBtn: {
    color: "white",
    backgroundColor: "#333399",
    '&:hover': {
      color: "#333399",
      backgroundColor: "white",
      borderColor: "#333399",
      border: '1px solid',
    }
  },
  neutralBtn: {
    color: "#333399",
    backgroundColor: "white",
    borderColor: "#333399",
    border: '1px solid',
    '&:hover': {
      color: "white",
      backgroundColor: "#333399",

      transition: '0.3s',
    }
  }
}))

const POI_TYPES = [
  {type: "HEALTH", description: "Health", value: "HEALTH"},
  {type: "LANDMARK", description: "Landmark", value: "LANDMARK"},
  {type: "NATURAL_FEATURE", description: "Natural feature", value: "NATURAL_FEATURE"},
  {type: "PLACE_OF_WORSHIP", description: "Place of worship", value: "PLACE_OF_WORSHIP"},
  {type: "FINANCE", description: "Finance", value: "FINANCE"},
  {type: "POLITICAL", description: "Political", value: "POLITICAL"},
  {type: "POST_BOX", description: "Post box", value: "POST_BOX"},
  {type: "TOWN_SQUARE", description: "Town square", value: "TOWN_SQUARE"},
  {type: "LOCALITY", description: "Locality", value: "LOCALITY"},
  {type: "BUS_STATION", description: "Bus station", value: "BUS_STATION"},
  {type: "TRAIN_STATION", description: "Train station", value: "TRAIN_STATION"},
  {type: "TRAIN_STwATION", description: "Train wstation", value: "TRAINw_STATION"},
  {type: "FOOD", description: "Food", value: "FOOD"}];

const PLACE_STATUSES = [
  {description: "Active", value: "OPERATIONAL"},
  {description: "Closed", value: "CLOSED_TEMPORARILY"},
  {description: "Closed Temporarily", value: "CLOSED_PERMANENTLY"},
]

const initialValues = {
  shortName: '',
  description: '',
  cityUuid: '',
  type: '',
  status: '',
}

const validationSchema = Yup.object({
  status: Yup.string().required().label("Status "),
  shortName: Yup.string().required().label("Name "),
  description: Yup.string().required().label("Description "),
  cityUuid: Yup.string().required().label("City "),
  type: Yup.string().required().label("Category "),
});
const host = process.env.REACT_APP_HOST;

const PoiCreateModal = ({cities, search, setOpenModal, location, setLocation, setOpenUploadIconModal, setPoiId}) => {
  const [openConfirmationModal, setOpenConfirmationModal] = useState({
    isOpen: false,
    success: true
  });

  const styles = useStyles();

  useEffect(() => {
    search();
  }, [])

  const handleSubmit = async (values) => {

    const body = {
      ...values,
      lat: location.lat,
      lng: location.lng,
    }

    const response = await axios
      .post(`${host}/place/`, body, config())
      .catch((e) => alert(e));

    if (response?.status >= 200 && response?.status < 300) {
      setPoiId(response.data['id'])
      setOpenConfirmationModal({
        isOpen: true,
        success: true
      })
    } else {
      setOpenConfirmationModal({
        isOpen: true,
        success: false
      })
    }
  }

  const cityTypes = [];
  if (cities) {
    cities?.content.map(city => cityTypes.push({
      value: city.uuid,
      description: city.cityName
    }));
  }

  return (
    <Card className={styles.card}>
      <DialogTitle
        id="Users Action Modal"
        style={{
          color: "white",
          backgroundColor: "#333399",
          textAlign: "left",
        }}
      >
        <label>Create New POI</label>
      </DialogTitle>
      <div className="card-body">
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={(values) => handleSubmit(values)}>
          {(formik, isSubmitting, values) => (
            <Form>
              <Grid item xs={12}>
                <Grid container spacing={2} className="formLabel px-3">
                  <Grid item xs={12}>
                    <InputTextField name="shortName" label="Name"/>
                  </Grid>
                  <Grid item xs={12}>
                    <Grid container spacing={2} justify="space-around" className="px-3">
                      <RadioButtonField name="status" options={PLACE_STATUSES} row/>
                    </Grid>
                  </Grid>
                  <Grid item xs={12}>
                    <InputTextField name="description" label="Description"/>
                  </Grid>
                  <Grid item xs={12}>
                    <SelectField name="type" label="Category" options={POI_TYPES}/>
                  </Grid>
                  <Grid item xs={12}>
                    <SelectField name="cityUuid" label="City" options={cityTypes}/>
                  </Grid>
                </Grid>
              </Grid>
              <FormNavigation onCancel={() => {
                setOpenModal(false);
                setLocation({
                  lat: "",
                  lng: ""
                })
              }}/>
            </Form>
          )}
        </Formik>
      </div>
      <ConfirmationCreatePoiModal
        confirmationModal={openConfirmationModal}
        setOpenUploadIconModal={setOpenUploadIconModal}
        setOpenConfirmationModal={setOpenConfirmationModal}
        setOpenModal={setOpenModal}
        setLocation={setLocation}
      />
    </Card>
  );
};

const mapStateToProps = (state) => ({
  cities: state.cityReducer.cities
});

const mapDispatchToProps = (dispatch) => ({
  search: (params) => dispatch(search(params)),
});


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withAuth0(PoiCreateModal));